export default __webpack_public_path__ + "images/design-examples/3 primer rabochego proecta с текстом-03.png";